import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Password } from 'src/app/class/session/session';
import Validation from 'src/app/class/validations/validation';
import { SessionService } from 'src/app/service/session.service';
import { AlertViewService } from 'src/app/services/alert-view.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {


  form: FormGroup;
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private sessionService: SessionService,
    private alertService: AlertViewService,
  ) { }

  ngOnInit(): void {

    this.form = this.formBuilder.group(
      {

        email: ['', [Validators.required, Validators.email]],
        password: [
          '',
          [
            Validators.required
          ]
        ],
      }
    );



  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }


    const account = new Password(this.form.value);
    this.sessionService.login(account);
    if (environment.debug) {
      console.log(JSON.stringify(this.form.value, null, 2));
    }
  }



}
